import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";


import Home from './Pages/Home';
import About from './Pages/About';
import Header from './Component/Header';

//import Timetable from './Pages/admincu/Timetable';
//import Listname from './Pages/admincu/Listname';
import Footter from './Component/Footter';

import Homepage from './Pages/Homepage';
import Pagework from './Pages/usersor/Pagework';
import Pageworkuser from './Pages/usersor/Pageworkuser';
import Pageworkgraphic from './Pages/usersor/Pageworkgraphic';
import Pageworkgraphicreport from './Pages/usersor/Pageworkgraphicreport';
import Pageworkmanufacture from './Pages/usersor/Pageworkmanufacture';
import Pageworkreport from './Pages/usersor/Pageworkreport';
import Pageworkreportpay from './Pages/usersor/Pageworkreportpay';
import Pageworkmanufactureinstall from './Pages/usersor/Pageworkmanufactureinstall';
import Pageworkmanufacturereport from './Pages/usersor/Pageworkmanufacturereport';
import Pageworkinstallrereport from './Pages/usersor/Pageworkinstallrereport';
import Pageworkuserwait from './Pages/usersor/Pageworkuserwait';
import Pageworkusercancel from './Pages/usersor/Pageworkusercancel';

import WebcamImage from './Pages/Tesst';
import Homelucky from './Pages/userlucky/Homelucky';

import Registerroom from './Pages/userlucky/Registerroom';
import Webcameras from './Pages/userlucky/Webcameras';
import Roommanagement from './Pages/userlucky/Roommanagement';
import Roomshowstatus from './Pages/userlucky/Roomshowstatus';
import RoomReport from './Pages/userlucky/RoomReport';
import RoomReportmoney from './Pages/userlucky/RoomReportmoney';
import RoomReportmoneyday from './Pages/userlucky/RoomReportmoneyday';
















export default class Routes extends Component {


    
    render() {
        return (
            <>
    
    
   
            <Router basename="luckyresortkpp" >
                <Header />
                <br/>
                <div className="content-container"> 
               <Switch>
                  
            
                    <Route exact path="/" component={Homepage} />
                    <Route exact path="/login" component={Homepage} />
                  
                    <Route exact path="/Pagework" component={Pagework} />
                    <Route exact path="/Pageworkuser" component={Pageworkuser} />
                    <Route exact path="/Pageworkgraphic" component={Pageworkgraphic} />
                    <Route exact path="/Pageworkgraphicreport" component={Pageworkgraphicreport} />
                    <Route exact path="/Pageworkmanufacture" component={Pageworkmanufacture} />
                    <Route exact path="/Pageworkreport" component={Pageworkreport} />
                    <Route exact path="/Pageworkreportpay" component={Pageworkreportpay} />
                    <Route exact path="/Pageworkmanufactureinstall" component={Pageworkmanufactureinstall} />
                    <Route exact path="/Pageworkmanufacturereport" component={Pageworkmanufacturereport} />
                    <Route exact path="/Pageworkinstallrereport" component={Pageworkinstallrereport} />
                    <Route exact path="/Pageworkuserwait" component={Pageworkuserwait} />
                    <Route exact path="/Pageworkusercancel" component={Pageworkusercancel} />

                    <Route exact path="/Tesst" component={WebcamImage} />
                    <Route exact path="/Homelucky" component={Homelucky} />
                    <Route exact path="/Registerroom/:id" component={Registerroom} />
                    <Route exact path="/Webcameras" component={Webcameras} />
                    <Route exact path="/Roommanagement" component={Roommanagement} />
                    <Route exact path="/Roomshowstatus" component={Roomshowstatus} />
                    <Route exact path="/RoomReport" component={RoomReport} />
                    <Route exact path="/RoomReportmoney" component={RoomReportmoney} />
                    <Route exact path="/RoomReportmoneyday" component={RoomReportmoneyday} />

                    <Route render={function () {return <h1>Not Found</h1> }} />
                </Switch> <br/>
</div>
               <footer className="footer--pin">
  <Footter />
</footer>
               
            </Router>
            
        
          </>  
        )
    }
}
